// extracted by mini-css-extract-plugin
export default {"root":"_3f-TD","warning":"_1e3v8"};